
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginEntityService } from '../services/entity-services/login-entity.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export const rightsGuard: CanActivateFn = (route, state) => {

  const router = inject(Router);
  const rightsService = inject(LoginEntityService);

  // Role-based guard (fast path) — checked before business-process API lookup
  const expectedRoles: string[] = route.data['expectedRoles'];
  if (expectedRoles?.length) {
    const rawRoles = localStorage.getItem('roles');
    const userRoles: string[] = rawRoles
      ? JSON.parse(rawRoles).map((r: string) => r.toLowerCase())
      : [];
    const allowed = expectedRoles.some(r => userRoles.includes(r.toLowerCase()));
    if (!allowed) {
      router.navigate(['/no-access']);
      return of(false);
    }
  }

  const businessProcess = route.data['businessProcessesName'];
  const activity = route.data['activity'];

  if (businessProcess === null || businessProcess === undefined || activity === null || activity === undefined) {
    return of(true); // No specific business process or activity required, allow access
  }



  const userId = localStorage.getItem("userId");
  if (!userId) {
    router.navigate(['/no-access']);
    return of(false);
  }

  return rightsService.getBusinessProcessesByUserId(userId).pipe(
    map(businessProcesses => {
      if (businessProcesses && businessProcesses.length > 0) {
        const bp = businessProcesses.find((bp: { name: string | undefined; }) => bp.name === businessProcess);
        if (bp) {
          const activities = bp.activities || [];
          if (activities.some((a: any) => a.name === activity)) {
            return true; // ✅ allowed
          } else {
             router.navigate(['/no-access']);
            return false; // ❌ not allowed
          }
        } else {
          router.navigate(['/no-access']);
          return false; // ❌ not allowed
        }
      } else {
         router.navigate(['/no-access']);
        return false;
      }
    }),
    catchError(() => {
      // router.navigate(['/no-access']);
      return of(false);
    })
  );
};
